import axios from "axios";
import store from "@/store";
import router from "@/router";
import core from "@/core/index";

class CoreHttp {
  headers = null;
  workList = [];
  workId = null;

  constructor() {
    this.headers = {
      default: {},
      form: {
        "content-type": "application/x-www-form-urlencoded",
      },
      json: {
        "content-type": "application/json",
      },
    };

    const defaultHeaders = [
      {
        key: "x-user-role",
        value: "manager",
      },
    ];

    for (const key of Object.keys(this.headers)) {
      const value = this.headers[key];
      defaultHeaders.forEach((data) => {
        value[data.key] = data.value;
      });
    }
  }

  objToUrlParams(obj, prefix) {
    const strList = [];
    for (const p in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, p)) {
        const k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        strList.push(
          v !== null && typeof v === "object"
            ? this.objToUrlParams(v, k)
            : encodeURIComponent(k) + "=" + encodeURIComponent(String(v))
        );
      }
    }
    return strList.join("&");
  }

  getJson(url, config, params) {
    if (config != null) {
      config.headers = this.headers.json;
    } else {
      config = { headers: this.headers.json };
    }
    return this.get(url, config, params);
  }

  get(url, config, params) {
    if (typeof params === "object") {
      url += "?" + this.objToUrlParams(params);
    }

    if (config == null || config.headers == null) {
      config = {
        headers: this.headers.default,
      };
    }

    const state = store.state;
    return new Promise((resolve, reject) => {
      if (url === "/api/user/me") {
        axios
          .get(url, config)
          .then((resp) => {
            state.auth.sessionCheckTime = new Date();
            resolve(resp.data);
          })
          .catch((reason) => {
            this.axiosError(reason, reject, config);
          });
      } else {
        this.pushWork({
          method: "get",
          url: url,
          config: config,
          params: params,
          resolve: resolve,
          reject: reject,
        });
      }
    });
  }

  putJson(url, params) {
    return this.put(url, params, { headers: this.headers.json });
  }

  put(url, params, config) {
    return new Promise((resolve, reject) => {
      this.pushWork({
        method: "put",
        url: url,
        config: config,
        params: params,
        resolve: resolve,
        reject: reject,
      });
    });
  }

  patchJson(url, params) {
    return this.patch(url, params, { headers: this.headers.json });
  }

  patch(url, params, config) {
    return new Promise((resolve, reject) => {
      this.pushWork({
        method: "patch",
        url: url,
        config: config,
        params: params,
        resolve: resolve,
        reject: reject,
      });
    });
  }

  postJson(url, params) {
    return this.post(url, params, { headers: this.headers.json });
  }

  post(url, params, config) {
    return new Promise((resolve, reject) => {
      this.pushWork({
        method: "post",
        url: url,
        config: config,
        params: params,
        resolve: resolve,
        reject: reject,
      });
    });
  }

  delete(url, config) {
    if (config == null) config = { headers: this.headers.default };
    else if (config.headers == null) config.headers = this.headers.default;

    return new Promise((resolve, reject) => {
      this.pushWork({
        method: "delete",
        url: url,
        config: config,
        resolve: resolve,
        reject: reject,
      });
    });
  }

  async work() {
    const state = store.state;

    const workItem = this.workList.shift();
    if (state.auth.sessionCheckTime != null) {
      const curTime = new Date();
      if (curTime.getTime() - state.auth.sessionCheckTime.getTime() > 300000) {
        // 세션확인시간 5분 이상 경과됬을 경우 회원정보 갱신
        const user = await store.dispatch("auth/getUser");
        if (user == null) {
          console.log("login session 만료");
        }
      }
    }

    if (workItem.method === "get") {
      axios
        .get(workItem.url, workItem.config)
        .then((resp) => {
          state.auth.sessionCheckTime = new Date();
          workItem.resolve(resp.data);
        })
        .catch((reason) => {
          this.axiosError(reason, workItem.reject, workItem.config);
        });
    } else if (workItem.method === "put") {
      axios
        .put(workItem.url, workItem.params, workItem.config)
        .then((resp) => {
          state.auth.sessionCheckTime = new Date();
          workItem.resolve(resp.data);
        })
        .catch((reason) => {
          this.axiosError(reason, workItem.reject, workItem.config);
        });
    } else if (workItem.method === "patch") {
      axios
        .patch(workItem.url, workItem.params, workItem.config)
        .then((resp) => {
          state.auth.sessionCheckTime = new Date();
          workItem.resolve(resp.data);
        })
        .catch((reason) => {
          this.axiosError(reason, workItem.reject, workItem.config);
        });
    } else if (workItem.method === "post") {
      axios
        .post(workItem.url, workItem.params, workItem.config)
        .then((resp) => {
          state.auth.sessionCheckTime = new Date();
          workItem.resolve(resp.data);
        })
        .catch((reason) => {
          this.axiosError(reason, workItem.reject, workItem.config);
        });
    } else if (workItem.method === "delete") {
      axios
        .delete(workItem.url, workItem.config)
        .then((resp) => {
          state.auth.sessionCheckTime = new Date();
          workItem.resolve(resp.data);
        })
        .catch((reason) => {
          this.axiosError(reason, workItem.reject, workItem.config);
        });
    }

    //console.log("workList.length : ", this.workList.length);
    if (this.workList.length > 0) {
      await this.work();
    }
  }

  pushWork(params) {
    // 서버단 RememberMe 처리 오류 때문에 작업 목록 따로 처리하면서 세션 확인함
    this.workList.push(params);
    if (this.workId == null) {
      this.workId = setTimeout(async () => {
        try {
          await this.work();
        } catch (e) {
          console.log(e);
        }
        this.workId = null;
      }, 1);
    }
  }

  axiosError(error, reject, config) {
    if (error.response != null) {
      // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
      //console.log(error.response.data);
      // console.log(error.response);
      let ignoreAlertModal = false;
      if (config != null && config.ignoreAlertModal) {
        ignoreAlertModal = config.ignoreAlertModal;
      }
      if (Number(error.response.status) >= 500) {
        core.alert.show({
          title: "알림",
          icon: "error",
          body: error.response.statusText,
          confirmButtonText: "확인",
        });
        reject({
          code: error.response.status,
          message: error.response.statusText,
        });
      } else {
        const errorData = error.response.data;
        // if (!error.config.ignoreAlert && errorData.errorFieldName == null) {
        if (errorData.errorFieldName == null) {
          let message = errorData.message;
          if (message == null || message.length === 0) {
            if (Number(error.response.status) == 401) {
              message = "로그인 세션이 만료되었습니다";
            } else {
              message = errorData.error;
            }
          }
          if (!ignoreAlertModal) {
            core.alert.show({
              title: "알림",
              icon: "error",
              body: message,
              confirmButtonText: "확인",
            });
          }
        }

        if (Number(error.response.status) == 401) {
          const state = store.state;
          if (state.auth.user != null) {
            store.commit("auth/logout");
            router.push("/");
          }
        }
        reject(errorData);
      }
    } else if (error.request) {
      // 요청이 이루어 졌으나 응답을 받지 못했습니다.
      // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
      // Node.js의 http.ClientRequest 인스턴스입니다.
      console.log("Error : ", error.message);
      core.alert.show({
        title: "알림",
        icon: "error",
        body: error.message,
        confirmButtonText: "확인",
      });
      reject({
        code: 0,
        message: error.message,
      });
    } else {
      // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
      console.log("Error : ", error.message);
      core.alert.show({
        title: "알림",
        icon: "error",
        body: error.message,
        confirmButtonText: "확인",
      });
      reject({
        code: -1,
        message: error.message,
      });
    }
  }

  downloadFile(url) {
    return axios({
      url: url,
      responseType: "arraybuffer",
    })
      .then((res) => {
        try {
          const blob = new Blob([res.data], { type: res.headers["content-type"] });
          let fileName = this.getFileName(res.headers["content-disposition"]);
          fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

          if (window.navigator.msSaveOrOpenBlob) {
            // IE 10+
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // not IE
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.target = "_self";
            if (fileName) link.download = fileName;
            link.click();
          }
        } catch (e) {
          console.error(e);
        }
      })
      .catch((res) => {
        // status 200이 아닌경우에도 콜백호출 (프로젝트에 맞게 수정필요)
        console.log(res);
      });
  }

  getFileName(contentDisposition) {
    const fileName = contentDisposition
      .split(";")
      .filter((ele) => {
        return ele.indexOf("filename") > -1;
      })
      .map((ele) => {
        return ele.replace(/"/g, "").split("=")[1];
      });
    return fileName[0] ? fileName[0] : String(new Date().getTime());
  }
}

export default new CoreHttp();
